export const API_YEAR = 2020
